var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99175 0.666687C4.39175 0.666687 0.666748 4.40002 0.666748 9.00002C0.666748 13.6 4.39175 17.3334 8.99175 17.3334C13.6001 17.3334 17.3334 13.6 17.3334 9.00002C17.3334 4.40002 13.6001 0.666687 8.99175 0.666687ZM9.00008 15.6667C5.31675 15.6667 2.33341 12.6834 2.33341 9.00002C2.33341 5.31669 5.31675 2.33335 9.00008 2.33335C12.6834 2.33335 15.6667 5.31669 15.6667 9.00002C15.6667 12.6834 12.6834 15.6667 9.00008 15.6667ZM9.41675 4.83335H8.16675V9.83335L12.5417 12.4584L13.1667 11.4334L9.41675 9.20835V4.83335Z",
    fill: "#242D30"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.7776378fe7c5de56b553f9b7f9beedcf.svg";
export { ForwardRef as ReactComponent };